import { useEffect } from "react";

const useScript = (url: string) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      try {
        document.body.removeChild(script);
      }catch (error) {
        console.info("useScript");
      }
    };
  }, [url]);
};

export default useScript;
